import { create } from 'zustand'

import { updateUser } from '../../../flecto-api/shared'
import { type CoreLocale } from '../../../flecto-types/src'
import i18n from '../i18n'

export type UseLanguageStateOptions = {
  withTranslated?: boolean
}

type Language = {
  flag: string
  name: string
  locale: CoreLocale
}

type LanguageState = {
  currentLanguage: Language
  supportedLanguages: Language[]
  changeLanguage: (locale: CoreLocale, syncOnUser?: boolean) => Promise<void>
}

export const useLanguageState = create<LanguageState>((set, get) => ({
  currentLanguage: {
    flag: '🇵🇹',
    name: 'Português',
    locale: 'pt',
  },
  supportedLanguages: [
    {
      flag: '🇵🇹',
      name: 'Português',
      locale: 'pt' as CoreLocale,
    },
    {
      flag: '🇬🇧',
      name: 'English',
      locale: 'en' as CoreLocale,
    },
    {
      flag: '🇪🇸',
      name: 'Español',
      locale: 'es' as CoreLocale,
    },
  ],
  changeLanguage: async (locale, syncOnUser = true) => {
    const language = get().supportedLanguages.find(
      (language) => language.locale === locale
    )

    if (language) {
      set({ currentLanguage: language })
      await i18n.changeLanguage(locale)

      if (syncOnUser) {
        await updateUser({ locale })
      }
    }
  },
}))
